import gql from 'graphql-tag';
import { compose, graphql } from 'react-apollo';

import OrderInvoices from './OrderInvoices';

interface InputProps {
  domain: string;
}

const CreateInvoiceMutation = gql`
  mutation createInvoice($orderId: String!, $invoiceType: String!, $sendToCustomer: Boolean) {
    createInvoice(orderId: $orderId, invoiceType: $invoiceType, sendToCustomer: $sendToCustomer) {
      invoice {
        id
      }
      sendToCustomer
      missingAuthorization
      popUpUrl
    }
  }
`;

const UpdateInvoiceMutation = gql`
  mutation updateOrder($id: String!, $data: UpdateInvoiceInput) {
    updateInvoice(id: $id, data: $data) {
      id
    }
  }
`;

const LetterDataQuery = gql`
  query letterData($domain: String!) {
    letterData(domain: $domain) {
      id
      sendInvoiceToCustomer
      sendProformaToCustomer
    }
  }
`;

export default compose(
  graphql<any, Response>(CreateInvoiceMutation, {
    name: 'createInvoice'
  }),
  graphql<any, Response>(UpdateInvoiceMutation, {
    name: 'updateInvoice'
  }),
  graphql<InputProps, Response>(LetterDataQuery, {
    name: 'letterData',
    options: (props: InputProps) => ({
      variables: {
        domain: props.domain,
      },
      fetchPolicy: 'network-only'
    })
  }),
)(OrderInvoices);



// WEBPACK FOOTER //
// ./src/scenes/OrderView/OrderView/OrderInvoices/index.ts